import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationBG from './locales/bg/translation.json';
import translationEN from './locales/en/translation.json';
import { getLangFromPath, DEFAULT_LANGUAGE, LANGUAGES } from './utils/languageUtils';

const resources = {
  bg: { translation: translationBG },
  en: { translation: translationEN },
};

// The URL path is the single source of truth for the active language
// (/about -> bg, /en/about -> en). Detecting it from a cookie instead would
// serve two different languages from one URL, which search engines cannot index.
i18n.use(initReactI18next).init({
  resources,
  lng: getLangFromPath(window.location.pathname),
  fallbackLng: DEFAULT_LANGUAGE,
  supportedLngs: [LANGUAGES.BG, LANGUAGES.EN],
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
